import { render, staticRenderFns } from "./selColorPartes.vue?vue&type=template&id=2db9df53&scoped=true&"
import script from "./selColorPartes.vue?vue&type=script&lang=js&"
export * from "./selColorPartes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db9df53",
  null
  
)

export default component.exports